module.exports = __webpack_public_path__ + "img/overview-icon.dfd2f543.svg";